export default __webpack_public_path__ + "static/jetson_vehicle_front-2fd63f12037e193d7a37562e1d24bce4.png";